import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

const Certificate = () => {
  // Filenames of certificates inside public/assets/certificates
  const imageFilenames = [
    "3.jpg", "certification.jpg", "1.jpg", "2.jpg", "4.jpg",
    "5.jpg", "6.jpg", "7.jpg", "8.jpg", "9.jpg",
    "10.jpg", "11.jpg", "12.jpg", "13.jpg", "14.jpg"
  ];

  // Map filenames to public folder paths
  const images = imageFilenames.map(
    (filename) => `/assets/certificates/${filename}`
  );

  return (
    <div>
      <Navbar />

      <section className="py-[50px] bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-gray-800 mb-10">
            CERTIFICATES
          </h2>

          {/* Image Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {images.map((src, index) => (
              <div key={index} className="w-full">
                <img
                  src={src}
                  alt={`Certificate ${index + 1}`}
                  className="rounded-xl w-full h-[300px] object-cover cursor-pointer hover:scale-105 transition-transform duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Certificate;
